<template>
    <div>
        <el-dialog title="使用凭证模版" class="mbDialogCss" width="60%" :visible.sync="dialogFormVisible">
            <div>
                <div class="header-div" style="text-align: right">
                    <div style="float: right">
                        <el-button size="mini" @click="handleFind()" style="background-color:#409EFF;color: white;">
                            查询<i class="el-icon-search"></i>
                        </el-button>
                    </div>
                    <div style="float: right">
                        <el-input
                                class="queryInput"
                                size="mini"
                                placeholder="请输入查询条件"
                                v-model="markName"
                                clearable>
                        </el-input>
                    </div>
                </div>

                <el-table
                        height="500"
                        :row-style="{height: '0'}"
                        :cell-style="{padding: '3.5px',color:'#606266',fontSize:'13.5px'}"
                        :header-row-style="{height: '40px'}"
                        :header-cell-style="{padding: '5px',fontSize:'14px',color:'#909399'}"
                        :data="tableData"
                        :span-method="objectSpanMethod"
                        :row-class-name="rowClassName"
                        @cell-mouse-enter="handleMouseEnter"
                        @cell-mouse-leave="handleMouseLeave"
                        size="mini"
                        id="elTableIdWW"
                        border
                        style="width: 100%; margin-top: 20px">
                    <el-table-column
                            prop="mbna"
                            label="模版名称"
                            width="266">
                    </el-table-column>
                    <el-table-column
                            min-width="126" :show-overflow-tooltip="true"
                            prop="zyJl"
                            label="摘要">
                    </el-table-column>
                    <el-table-column
                            min-width="166" :show-overflow-tooltip="true"
                            prop="kmmc"
                            label="科目">

                        <template slot-scope="scope">
                            {{scope.row.kmdm}}
                            {{scope.row.kmmc}}
                        </template>

                    </el-table-column>
                    <el-table-column label="操作" width="156">
                        <template slot-scope="scope">
                            <a style="color: #3cbaff;cursor: pointer;margin-right: 25px;"
                               @click="handleSelectMb(scope.row)">选择模版</a>

                            <el-popconfirm title="确定删除吗？" @onConfirm="handleDelete(scope.row)">
                                <el-button size="mini" slot="reference" v-if="$hasPerm('business:fuZhuPzmb:remove')" type="text">删除<i class="el-icon-delete"></i></el-button>
                            </el-popconfirm>
                        </template>
                    </el-table-column>
                </el-table>

                <el-pagination
                        style="margin-top: 5px;"
                        background
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                        :page-sizes="[5, 10, 20, 50, 90, 500]"
                        :page-size="pageSize"
                        :current-page="currentPage"
                        @current-change="handleCurrentChange"
                        @size-change="handleSizeChange"
                ></el-pagination>
            </div>
        </el-dialog>
    </div>
</template>

<script>

    export default {
        data() {
            return {
                dialogFormVisible: false,
                currentPage: 1, //初始页
                pageSize: 10, //    每页的数据
                total: 0,
                offset: 0,
                tableData: [],
                markName: ''
            }
        },
        methods: {
            int() {
                this.dialogFormVisible = true;
                this.handleCurrentChange(this.currentPage);
            },
            handleSelectMb(row) {
                this.dialogFormVisible = false
                this.$emit("handleSelectMb", row.mbId);
            },
            handleCurrentChange(cPage) {
                this.offset = (cPage - 1) * this.pageSize;
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/fuZhuPzmb/list'),
                    method: 'get',
                    params: {
                        'offset': this.offset,
                        'limit': this.pageSize,
                        'sta': '0',
                        'markName': this.markName
                    }
                }).then(r => {
                    if (r.data.code == 0) {
                        this.tableData = r.data.data.rows;
                        this.total = r.data.data.total;
                    } else {
                        this.$message({ // 失败
                            type: 'error',
                            message: r.data.msg
                        })
                    }
                })

            },
            // 合并规则
            objectSpanMethod({row, column, rowIndex, columnIndex}) {
                if (columnIndex === 0 || columnIndex === 3) {
                    if (row.rowFirst === true) {
                        return {
                            rowspan: row.rowspan,
                            colspan: 1
                        }
                    } else {
                        return {
                            rowspan: 0,
                            colspan: 0
                        }
                    }
                }
            },
            // 给相应的rowIndex添加类名
            rowClassName({row}) {
                return row.mbId;
            },
            // 鼠标进入单元格
            handleMouseEnter(row) {
                $("." + row.mbId + "").addClass("in-row");
            },
            // 鼠标离开
            handleMouseLeave(row) {
                $("." + row.mbId + "").removeClass("in-row");
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.handleCurrentChange(1);
            },
            handleFind() {
                this.handleCurrentChange(1);
            },
            handleDelete(row) {
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/fuZhuPzmb/remove'),
                    method: 'post',
                    data: this.$httpTAG.adornData({id: row.mbId})
                }).then(res => {
                    if (res.data.code == 0) {
                        this.$notify({
                            title: '操作成功！',
                            type: 'success',
                            offset: 600
                        });
                        this.handleCurrentChange(1);
                    } else {
                        this.$message({ // 失败
                            type: 'error',
                            message: res.data.msg
                        })
                    }
                })
            }
        }
    }
</script>
<style scoped>
    .header-div {
        margin-bottom: 5px;
        float: left;
        width: 100%;
        text-align: right;
    }

    .queryInput >>> .el-input__inner {
        border-radius: 0px;
        width: 150px;
    }

    .mbDialogCss >>> .el-dialog__body {
        padding: 5px 35px 25px 35px;
    }
</style>